<div class="flex flex-column h-full">
    <div class="flex align-items-center border-bottom-1 surface-border p-3 lg:p-6">
        <div class="relative flex align-items-center mr-3">
            <img src="assets/demo/images/avatar/{{user.image}}" alt="user.name" class="w-4rem h-4rem border-circle shadow-4">
            <span class="w-1rem h-1rem border-circle border-2 surface-border absolute bottom-0 right-0" [ngClass]="{'bg-green-400': user.status === 'active', 'bg-red-400': user.status === 'busy', 'bg-yellow-400': user.status === 'away'}"></span>
        </div>
        <div class="mr-2">
            <span class="text-900 font-semibold block">{{user.name}}</span>
            <span class="text-700">Last active 1 hour ago</span>
        </div>
        <div class="flex align-items-center ml-auto">
            <button pButton pRipple type="button" icon="pi pi-phone" class="p-button-rounded p-button-outlined p-button-secondary mr-3"></button>
            <button pButton pRipple type="button" icon="pi pi-ellipsis-v" class="p-button-rounded p-button-outlined p-button-secondary"></button>
        </div>
    </div>
    <div class="p-3 md:px-4 lg:px-6 lg:py-4 mt-2 overflow-y-auto" style="max-height: 53vh;" #chatWindow [scrollTop]="chatWindow.scrollHeight">
        <div *ngFor="let message of user.messages">
            <div *ngIf="message.ownerId !== 123" class="grid grid-nogutter mb-4">
                <div class="mr-3 mt-1">
                    <img src="assets/demo/images/avatar/{{user.image}}" alt="user.name" class="w-3rem h-3rem border-circle shadow-4">
                </div>
                <div class="col mt-3">
                    <p class="text-900 font-semibold mb-3">{{user.name}}</p>
                    <span class="text-700 inline-block font-medium border-1 surface-border p-3 white-space-normal border-round" style="word-break: break-word; max-width:80%;">{{message.text}}</span>
                    <p class="text-700 mt-3">{{parseDate(message.createdAt)}}<i class="pi pi-check ml-2 text-green-400"></i></p>
                </div>
            </div>

            <div *ngIf="message.ownerId === defaultUserId" class="grid grid-nogutter mb-4">
                <div class="col mt-3 text-right">
                    <span class="inline-block text-left font-medium border-1 surface-border bg-primary-100 text-primary-900 p-3 white-space-normal border-round" style="word-break: break-word; max-width:80%;">{{message.text}}</span>
                    <p class="text-700 mt-3">{{parseDate(message.createdAt)}} <i class="pi pi-check ml-2 text-green-400"></i></p>
                </div>
            </div>
        </div>
    </div>
    <div class="p-3 md:p-4 lg:p-6 flex flex-column sm:flex-row align-items-center mt-auto border-top-1 surface-border gap-3">
        <input id="message" type="text" pInputText placeholder="Type a message" class="flex-1 w-full sm:w-auto border-round" [(ngModel)]="textContent" (keydown.enter)="sendMessage()"/>
        <div class="flex w-full sm:w-auto gap-3">
            <button pRipple class="p-button p-button-secondary w-full sm:w-auto justify-content-center text-xl" (click)="op.toggle($event)">😀</button>
            <button pButton pRipple label="Send" icon="pi pi-send" class="w-full sm:w-auto" (click)="sendMessage()"></button>
        </div>
    </div>
</div>

<p-overlayPanel #op styleClass="w-full sm:w-30rem">
    <ng-template pTemplate>
        <button *ngFor="let emoji of emojis;" pButton pRipple (click)="op.hide(); onEmojiSelect(emoji)" type="button" [label]="emoji" class="p-2 p-button-text text-2xl"></button>
    </ng-template>
</p-overlayPanel>